// Usuários não-MASTER que também podem acessar a tela de Update
const USUARIOS_UPDATE = ['rodrigo'];

export function podeAcessarUpdate() {
  if (localStorage.getItem('user-role') === 'MASTER') return true;
  const usuario = (localStorage.getItem('user-name') || '').trim().toLowerCase();
  return USUARIOS_UPDATE.includes(usuario);
}
